export const round = (value: unknown): string => {
  return Number(value).toFixed(2);
};

const tooltipAxisTypeGuard = (
  params: unknown,
): params is Array<{
  axisValue?: string;
  marker?: string;
  seriesName?: string;
  value?: unknown;
}> => {
  return (
    Array.isArray(params) &&
    params.every(
      (item) =>
        typeof item === "object" &&
        item !== null &&
        "axisValue" in item &&
        "marker" in item &&
        "seriesName" in item &&
        "value" in item,
    )
  );
};

export function formatTooltipAxis(params: unknown): string {
  if (!tooltipAxisTypeGuard(params)) return "";
  return params
    .map(
      (item) =>
        `${item.marker ?? ""} ${item.seriesName ?? ""}: ${round(
          item.value,
        )} mpg`,
    )
    .join("<br/>");
}

export function formatTooltipAxisWithUnit(
  params: unknown,
  unit: string,
): string {
  if (!tooltipAxisTypeGuard(params)) return "";
  return params
    .map(
      (item) =>
        `${item.marker ?? ""} ${item.seriesName ?? ""}: ${round(
          item.value,
        )} ${unit}`,
    )
    .join("<br/>");
}

const tooltipItemTypeGuard = (
  params: unknown,
): params is { name?: string; value?: unknown; percent?: unknown } => {
  return (
    typeof params === "object" &&
    params !== null &&
    "name" in params &&
    "value" in params &&
    "percent" in params
  );
};

export function formatTooltipItem(params: unknown): string {
  if (!tooltipItemTypeGuard(params)) return "";

  return `${params.name ?? ""}: ${round(params.value)} mpg (${round(
    params.percent,
  )}%)`;
}
